<!--
     Copyright (c) 2024 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->

<ul class="breadcrumb" *ngIf="breadcrumbService.breadcrumbElements?.length > 1">
    <ng-container *ngFor="let breadcrumbItem of breadcrumbService.breadcrumbElements">
        <li *ngIf="breadcrumbItem.url" class="breadcrumb-item">
            <a class="btn btn-sm btn-link" [routerLink]="breadcrumbItem.url">{{breadcrumbItem.label}}</a>
        </li>
        <li *ngIf="!breadcrumbItem.url" class="breadcrumb-item active">{{breadcrumbItem.label}}</li>
    </ng-container>
</ul>
